import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { WIDGET, } from "@voltmoney/schema";
import { navigateToNext } from "./actions";
import { ACTION } from "./types";
export const template = (height) => {
    return {
        layout: {
            id: ROUTE.CHECKING_LIMIT,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'mfCentralEvaluateFundsDC',
                    type: WIDGET.MFC_FETCH_EVALUATE_FUNDS,
                },
            ],
        },
        datastore: {
            mfCentralEvaluateFundsDC: {
                height: height,
            },
        },
    };
};
export const checkingLimitMf = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        [ACTION.NAVIGATE_NEXT]: navigateToNext,
    },
    action: {
        routeId: ROUTE.CHECKING_LIMIT,
        type: ACTION.NAVIGATE_NEXT,
        payload: {},
    },
    clearPrevious: true,
};
